import useSwr from "swr";
import * as AutoStatementApi from "../../apis/auto-statement";
import { ReminderApi } from "../../apis/reminder";

/** Хуудас болон табууд ижил key-ээр уншдаг тул давхар fetch хийгдэхгүй. late-fee-ийн hook нь hooks/use-late-fee-config.ts. */
export const useReminderConfigData = () => {
  const { data, isLoading, mutate } = useSwr("swr.reminder-config", () => ReminderApi.getConfig(), { revalidateOnFocus: false });
  return { data: data as any, isLoading, mutate };
};

export const useAutoStatementConfigData = () => {
  const { data, isLoading, mutate } = useSwr("swr.auto-statement-config", () => AutoStatementApi.getConfig(), {
    revalidateOnFocus: false,
  });
  return { data: data as any, isLoading, mutate };
};
